import axios from 'lib/axios';


const getDivination = async ({}) => {
  const { data } = await axios.get(`/divine`);
  return data;
};



export { getDivination };
